<template>
    <div v-if="LeavePolicyDocuments.length > 0" class="col-md-12" style="height: 100%;">
        <div class="row" style="padding-top: 15px; padding-bottom: 15px; margin-bottom: 15px;">
            <div class="col-md-12">
              Your organization's leave policy document(s)
            </div>
        </div>
        <div class="row">
             <div class="col-md-12">
                <template v-for="(item,index) in LeavePolicyDocuments">
                    <div class="attachments-view" v-if="item!= '' && item != null" >
                        <span>
                        {{item.FileName}}
                        </span>
                        <ob-popover trigger="click" :options="{placement: 'bottom'}">
                        <div class="popper" style="padding:0px">
                            <div style="padding:10px;">
                                <span :class="{'cursorCls': !isFileType(item.Url)}" >
                                    <span :class="{'hideShow': !isFileType(item.Url)}" style="display:inline-block;padding-right:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32" @click="printSingleDoc(item.Url)" /></span>
                                </span>
                                <span style="display:inline-block;padding:0 5px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32" @click="downloadSingleDoc(item.Url)" /></span>
                                <span style="display:inline-block;padding-left:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32" @click="previewSingleDoc(item.Url)" /></span>
                            </div>
                        </div>
                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15" slot="reference" style="cursor:pointer;display:inline-block;margin-left:10px" />
                    </ob-popover>
                    </div>
                 </template>
            </div>
        </div>
    </div>
    <div v-else class="row" style="padding:15px 0 15px 15px;margin:0">
            <div class="col-md-12">
              HR hasn't uploaded Leave policy documents.
            </div>
    </div>

</template>
<script>
import c from 'Vue/Core/constants.js'

import utils from "Vue/Core/utils.js";

import CommonFunctionMixin from '../Timesheets/CommonFunctionMixin.js'

export default {
    mixins: [CommonFunctionMixin],
    data() {
        return {
            LeavePolicyDocuments:[]
         }
    },
    components: {

    },
    computed: {
        OrganisationId(){
            return this.loggedInUserObj.orgId ? this.loggedInUserObj.orgId : '';
        }

    },
    created()
    {
        this.getLeavePolicyDocuments()
    },
    methods: {
        getLeavePolicyDocuments()
        {
            this.$loading({'loadingText': 'Loading...'})
            ajax.get(`/Leave/${this.OrganisationId}/LeavePolicyDocs`, {}, (res) => {
                this.LeavePolicyDocuments = res.data.LeavePolicyDocuments;
                this.$loading({}).close()
            })
        },
        isFileType(item)
        {
            var filename = utils.I9URL2FileName(item);
            var fileExtention = filename.split('.').pop();
            var FileTypes = ["pdf", "png", "gif", "jpg", "jpeg"];
            return FileTypes.includes(fileExtention)
        },
    }
}
</script>
<style scoped>

.control-label {
    color: #8695A5;
}
.form-control-static {
    color: #475259;
    font-weight: 600;
}
.section-title {
    color: #4D92DF;
    font-size: 13px;
    margin: 0 0 15px;
    font-weight: 600;
}
.section{
    color: rgb(103, 106, 108);
    font-size: 13px;
    margin: 0 0 15px;
    font-weight: 600;
}
.label {
    border-radius: 10px;
}
.attachments-view
{
    margin-top: 5px;
    /* color:#4A90E2; */
    margin-left: 0px;
    border: 1px solid #4A90E2 !important;
    background: #e6eff9  !important;
	padding: 5px 10px;
    display: inline-block;
    border-radius: 30px;
    font-weight: bold;
    float: left;
    margin-right: 2%;
}
.cursorCls
{
  cursor:not-allowed !important;
}
.hideShow
{
  pointer-events: none !important;
}

</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/LeaveManagement/LeavePolicy.vue